__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "AustinEhsRisk";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/austin-core", "2.168.0", () => (Promise.all([__webpack_require__.e(2839), __webpack_require__.e(4091), __webpack_require__.e(4318), __webpack_require__.e(8151), __webpack_require__.e(9802), __webpack_require__.e(5211), __webpack_require__.e(6515), __webpack_require__.e(5257), __webpack_require__.e(7856), __webpack_require__.e(1966), __webpack_require__.e(2541), __webpack_require__.e(3513), __webpack_require__.e(8221), __webpack_require__.e(2131), __webpack_require__.e(6759), __webpack_require__.e(4592), __webpack_require__.e(5607), __webpack_require__.e(4711), __webpack_require__.e(6915), __webpack_require__.e(9679), __webpack_require__.e(4027), __webpack_require__.e(1907), __webpack_require__.e(8386), __webpack_require__.e(1031), __webpack_require__.e(1135), __webpack_require__.e(3704), __webpack_require__.e(6425), __webpack_require__.e(5968)]).then(() => (() => (__webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"))))));
			register("@tanstack/react-query", "5.97.0", () => (Promise.all([__webpack_require__.e(7254), __webpack_require__.e(1135), __webpack_require__.e(7284), __webpack_require__.e(2540)]).then(() => (() => (__webpack_require__("../node_modules/@tanstack/react-query/build/modern/index.js"))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))));
			register("react-router-6", "6.30.0", () => (Promise.all([__webpack_require__.e(744), __webpack_require__.e(7435), __webpack_require__.e(8175)]).then(() => (() => (__webpack_require__("../node_modules/react-router/dist/index.js"))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(744), __webpack_require__.e(9348), __webpack_require__.e(8175), __webpack_require__.e(3043)]).then(() => (() => (__webpack_require__("../node_modules/react-router-dom/dist/index.js"))))));
			register("react", "18.3.1", () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};